<template>
  <div id="register">
    <h2>New Bowler Details</h2>
    <el-form
      novalidate="true"
      label-width="10em"
      :label-position="formLabelPosition"
      :size="formSize"
    >
      <div>
        <el-form-item label="Title" :error="errors.title">
          <el-select placeholder="Title" v-model="customer.title" filterable>
						<el-option
							v-for="title in titles"
							:key="title"
							:label="title"
							:value="title">
						</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="First Name" :error="errors.first_name">
          <el-input placeholder="First Name" v-model="customer.first_name"></el-input>
        </el-form-item>
        <el-form-item label="Last Name" :error="errors.last_name">
          <el-input placeholder="Last Name" v-model="customer.last_name"></el-input>
        </el-form-item>
        <el-form-item v-if="!customer.is_guest" label="Email address" :error="errors.email">
          <el-input placeholder="Enter your email" v-model="customer.email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="customer.is_guest">I don't have an email address</el-checkbox>
        </el-form-item>
        <el-form-item v-if="!customer.is_guest" label="Confirm email" :error="errors.email_confirmation">
          <el-input placeholder="Confirm your email" v-model="customer.email_confirmation"></el-input>
        </el-form-item>
        <el-form-item label="Phone Number" :error="errors.phone_number">
          <el-input placeholder="Phone Number" v-model="customer.phone_number"></el-input>
        </el-form-item>
        <el-form-item label="Postcode" :error="errors.zip_code" v-if="accountFields.includes('zip_code')">
          <el-input placeholder="Postcode" v-model="customer.zip_code" type="text" v-mask="postcodeMask"></el-input>
          <div class="postcode-lookup" v-if="hasGetAddress">
            <el-button type="primary" @click="postcodeLookup" :loading="getAddressStatus == 'pending'">Find Address</el-button>
            <el-select placeholder="Select an Address" v-if="addresses.length" v-model="selectedAddress">
              <el-option
                v-for="address, index in addresses"
                :key="index"
                :label="formatAddress(address)"
                :value="index"/>
             </el-select>
          </div>
        </el-form-item>
        <el-form-item label="Property Name/Number" :error="errors.street_number"  v-if="accountFields.includes('street_number')">
          <el-input placeholder="Property Name/Number" v-model="customer.street_number"></el-input>
        </el-form-item>
        <el-form-item label="Street" :error="errors.street" v-if="accountFields.includes('street')">
          <el-input placeholder="Street" v-model="customer.street"></el-input>
        </el-form-item>
        <el-form-item label="City" :error="errors.city"  v-if="accountFields.includes('city')">
          <el-input placeholder="City" v-model="customer.city"></el-input>
        </el-form-item>
        <el-form-item label="Country" :error="errors.country"  v-if="accountFields.includes('country')">
          <el-select placeholder="Country" v-model="customer.country" filterable>
						<el-option
							v-for="country in countries"
							:key="country"
							:label="country"
							:value="country">
						</el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!customer.is_guest" label="Password" :error="errors.password">
          <el-input placeholder="Enter your password" v-model="customer.password" show-password></el-input>
        </el-form-item>
        <el-form-item v-if="!customer.is_guest" label="Confirm Password" :error="errors.password_confirmation">
          <el-input placeholder="Confirm your password" v-model="customer.password_confirmation" show-password></el-input>
        </el-form-item>
        <el-form-item v-if="!customer.is_guest">
          <el-checkbox :label="allowEmailsLabel || 'I consent to being contacted by email'" v-model="customer.allow_e_mails" true-label="Yes" false-label="No" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="register">Register</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import formMixin from '../mixins/formMixin'
  import sessionMixin from '../mixins/sessionMixin'
  import profileMixin from '../mixins/profileMixin'

  export default {
    mixins: [formMixin, sessionMixin, profileMixin],
    computed: {
      ...mapState({
        allowEmailsLabel: state => state.settings.tenant.allow_emails_label,
        hasGetAddress: state => state.settings.tenant.has_get_address,
        accountFields: state => state.settings.tenant.account_fields
      })
    },
    methods: {
      register() {
        this.$store.dispatch('customer/createCustomer', this.customer)
      }
    }
  }
</script>
<style scoped>
  .el-alert {
    margin-bottom: 1em;
  }
  .postcode-lookup {
    margin-top: 0.5em;
  }
</style>
